__turbopack_context__.v({
  "disabled": "sx1WBG_disabled",
  "placeholder": "sx1WBG_placeholder",
  "text": "sx1WBG_text",
});
